import { render, staticRenderFns } from "./ProductRepair.vue?vue&type=template&id=28de2ee1&scoped=true"
import script from "./ProductRepair.vue?vue&type=script&lang=js"
export * from "./ProductRepair.vue?vue&type=script&lang=js"
import style0 from "./ProductRepair.vue?vue&type=style&index=0&id=28de2ee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de2ee1",
  null
  
)

export default component.exports